const darkTheme = {
  name: 'Midnight',
  colors: {
    // Main backgrounds
    background: '#0f172a',        // slate-900
    surface: '#1e293b',          // slate-800
    
    // Interactive elements
    primary: '#8b5cf6',          // violet-500
    primaryHover: '#7c3aed',     // violet-600
    primaryDark: '#6d28d9',      // violet-700
    secondary: '#a78bfa',        // violet-400
    accent: '#8b5cf6',           // violet-500
    
    // Text hierarchy
    text: {
      primary: '#f8fafc',        // slate-50
      secondary: '#e2e8f0',      // slate-200
      muted: '#94a3b8',          // slate-400
      disabled: '#64748b',       // slate-500
      button: '#ffffff',         // white
      link: '#a78bfa',           // violet-400
      linkHover: '#c4b5fd'       // violet-300
    },
    
    // Status & feedback
    status: {
      success: '#10b981',        // emerald-500
      successBg: '#064e3b',      // emerald-900
      error: '#ef4444',          // red-500
      errorBg: '#7f1d1d',        // red-900
      warning: '#f59e0b',        // amber-500
      warningBg: '#78350f',      // amber-900
      warningText: '#fbbf24',    // amber-400
      info: '#a78bfa',           // violet-400
      victory: '#15803d',        // green-700
      victoryTo: '#166534',      // green-800
      defeat: '#b91c1c',         // red-700
      defeatTo: '#991b1b',       // red-800
      errorHover: '#dc2626'      // red-600
    },
    
    // Interactive states
    hover: {
      light: '#334155',          // slate-700
      medium: '#475569',         // slate-600
      surface: '#374151'         // gray-700
    },
    
    // Borders & separators
    border: {
      light: '#475569',          // slate-600
      medium: '#64748b',         // slate-500
      strong: '#94a3b8'          // slate-400
    },
    
    // Badges & tags
    badge: {
      waiting: { bg: '#f59e0b', text: '#ffffff' },     // amber-500/white for better contrast
      active: { bg: '#475569', text: '#e2e8f0' },      // slate-600/slate-200 for better readability
      yourTurn: { bg: '#8b5cf6', text: '#ffffff' },    // violet-500/white
      opponentTurn: { bg: '#475569', text: '#cbd5e1' }, // slate-600/slate-300 lighter text
      win: { bg: '#10b981', text: '#ffffff' },         // emerald-500/white
      loss: { bg: '#ef4444', text: '#ffffff' }         // red-500/white
    },
    
    // Game-specific
    game: {
      flagClaimed: '#065f46',      // emerald-800
      flagClaimedBorder: '#10b981', // emerald-500
      flagLost: '#7f1d1d',         // red-900
      flagLostBorder: '#ef4444',   // red-500
      flagNeutral: '#374151',      // gray-700
      flagNeutralBorder: '#6b7280', // gray-500
      flagHighlight: '#6b46c1',    // violet-700 (muted purple)
      chatBackground: '#374151',   // gray-700
      // Invite/waiting states (dark theme variations)
      inviteBackground: 'rgba(139, 92, 246, 0.2)',
      inviteBorder: '#8b5cf6',
      inviteText: '#f8fafc',
      inviteInputBg: 'rgba(30, 41, 59, 0.9)',
      joinBackground: 'rgba(16, 185, 129, 0.2)',
      joinBorder: '#10b981',
      loadingText: '#a78bfa',
      // Chat error border
      chatErrorBorder: '#ef4444',
      // Button colors
      buttonPrimary: '#374151',
      buttonPrimaryHover: '#1f2937',
      buttonSecondary: '#f3f4f6'
    }
  }
};

export default darkTheme;